export default function SelectableOption({
  planName,
  planPrice,
  isSelected,
  onClick,
  disabled,
}: {
  planName: string;
  planPrice?: string;
  isSelected: boolean;
  onClick: () => void;
  disabled?: boolean;
}) {
  return (
    <div
      className={`flex flex-row items-center border ${
        disabled ? "opacity-50" : "hover:cursor-pointer"
      } ${
        isSelected ? "border-white font-bold" : "border-zinc-500 font-thin"
      }  rounded-xl w-full py-8 px-6 justify-between`}
      onClick={disabled ? undefined : onClick}
    >
      <div className="flex flex-row items-center gap-x-4">
        <div
          className={`rounded-full  ${
            isSelected ? "bg-white" : "border border-zinc-500"
          } h-5 w-5`}
        />
        <div>{planName}</div>
      </div>
      {planPrice && <div>{planPrice}</div>}
    </div>
  );
}
